import Splide from '@splidejs/splide';

/**
 * Number Cards block. Horizontal carousel below ~1704px; static 3-up grid above.
 * Progressive enhancement — without JS the source `.number-cards__grid` still renders.
 */
export const numberCardsCarousel = () => {
  const sources = document.querySelectorAll('.number-cards__grid');
  if (!sources.length) return;

  const carouselQuery = window.matchMedia('(max-width: 1703px)');
  const getSideMargin = () =>
    getComputedStyle(document.documentElement).getPropertyValue('--site-margin').trim() || '32px';

  sources.forEach((source) => {
    const list = source.cloneNode(true);
    list.setAttribute('class', 'splide__list');
    list.querySelectorAll('.number-cards__card').forEach((card) => card.classList.add('splide__slide'));

    const root = document.createElement('div');
    root.className = 'number-cards__carousel splide';

    const track = document.createElement('div');
    track.className = 'splide__track';

    track.appendChild(list);
    root.appendChild(track);

    source.classList.add('number-cards__grid--has-carousel');
    source.after(root);

    let splide = null;

    const sync = () => {
      if (carouselQuery.matches && !splide) {
        splide = new Splide(root, {
          focus: 'start',
          gap: '24px',
          fixedWidth: '300px',
          padding: { left: getSideMargin(), right: getSideMargin() },
          arrows: true,
          pagination: false,
        }).mount();
      } else if (!carouselQuery.matches && splide) {
        splide.destroy(true);
        splide = null;
      }
    };

    sync();
    carouselQuery.addEventListener('change', sync);
  });
};
